import React, {Suspense, lazy} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {ThemeProvider as TP} from '@material-ui/core/styles';
import {ThemeProvider as TP1} from 'styled-components';
import {UseWalletProvider} from 'use-wallet';
import usePromptNetwork from './hooks/useNetworkPrompt';
import BanksProvider from './contexts/Banks';
import ProfitProvider from './contexts/ProfitDistributions';

import BasedFinanceProvider from './contexts/BasedFinanceProvider';
import ModalsProvider from './contexts/Modals';
import store from './state';
import theme from './theme';
import newTheme from './newTheme';
import config from './config';
import Updaters from './state/Updaters';
import Loader from './components/Loader';
import Popups from './components/Popups';
import {RefreshContextProvider} from './contexts/RefreshContext';
import ParhtenonProvider from "./contexts/ParthenonProvider";
import useBasedFinance from "./hooks/useBasedFinance";
import KatastimaProvider from "./contexts/KatastimaProvider";

const Stoas = lazy(() => import('./views/Stoas'));
const Marketplace = lazy(() => import('./views/Marketplace'));
const Acropolis = lazy(() => import('./views/Acropolis'));
const Parthenon2 = lazy(() => import('./views/Parthenon/Parthenon'));
const Theatre = lazy(() => import('./views/Theatre'));
const Katastima = lazy(() => import('./views/Katastima/Katastima'));
const Metrics = lazy(() => import('./views/Metrics'));

const DashboardPage = lazy(() => import('./views/DashboardPage'));

const NoMatch = () => (
    <h3 style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
        URL Not Found. <a href="/">Go back home.</a>
    </h3>
);

const App: React.FC = () => {
    // Clear localStorage for mobile users
    if (typeof localStorage.version_app === 'undefined' || localStorage.version_app !== '1.1') {
        localStorage.clear();
        localStorage.setItem('connectorId', '');
        localStorage.setItem('version_app', '1.1');
    }

  usePromptNetwork();

    return (
        <Providers>
            <Router>
                <Suspense fallback={<Loader/>}>
                    <Switch>
                        <Route exact path="/">
                            <Stoas/>
                        </Route>
                        <Route path="/marketplace">
                            <Marketplace/>
                        </Route>
                        <Route path="/dashboard">
                            <DashboardPage/>
                        </Route>
                        <Route path="/acropolis">
                            <Acropolis/>
                        </Route>
                        <Route path="/parthenon">
                            <Parthenon2/>
                        </Route>
                        <Route path="/theatre">
                            <Theatre/>
                        </Route>
                        <Route path="/katastima">
                            <Katastima/>
                        </Route>
                        <Route path="/metrics">
                            <Metrics/>
                        </Route>
                        <Route path="*">
                            <NoMatch/>
                        </Route>
                    </Switch>
                </Suspense>
            </Router>
        </Providers>
    );
};

const Providers: React.FC = ({children}) => {
    return (
        <TP1 theme={theme}>
            <TP theme={newTheme}>
                <UseWalletProvider
                    chainId={config.chainId}
                    connectors={{
                        walletconnect: {rpcUrl: config.defaultProvider},
                        walletlink: {
                            url: config.defaultProvider,
                            appName: 'Based Finance',
                            appLogoUrl: 'https://github.com/basedfinance/basedfinance-assets/blob/master/logo_based_NoBG.png',
                        },
                    }}
                >
                    <Provider store={store}>
                        <Updaters/>
                        <RefreshContextProvider>
                            <BasedFinanceProvider>
                                <ModalsProvider>
                                    <BanksProvider>
                                        <ProfitProvider>
                                            <ParhtenonProvider>
                                                <KatastimaProvider>
                                                    <>
                                                        <Popups/>
                                                        {children}
                                                    </>
                                                </KatastimaProvider>
                                            </ParhtenonProvider>
                                        </ProfitProvider>
                                    </BanksProvider>
                                </ModalsProvider>
                            </BasedFinanceProvider>
                        </RefreshContextProvider>
                    </Provider>
                </UseWalletProvider>
            </TP>
        </TP1>
    );
};

export default App;
